import { render } from "./SkiSchoolContainer.vue?vue&type=template&id=31afbe68&scoped=true"
import script from "./SkiSchoolContainer.vue?vue&type=script&lang=js"
export * from "./SkiSchoolContainer.vue?vue&type=script&lang=js"

import "./SkiSchoolContainer.vue?vue&type=style&index=0&id=31afbe68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31afbe68"]])

export default __exports__